module.exports = __webpack_public_path__ + "static/media/BANNERS_CONFIRMACION_PSE_BANNER_GANADOR.6a5df42d.jpg";